import { FormattedMessage } from 'react-intl';

interface Props {
  labelId: string;
  onClick: () => void;
  disabled?: boolean;
}

export default function AddSpanButton({ labelId, onClick, disabled = false }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="inline-flex items-center gap-1.5 rounded-lg text-sm font-semibold text-brand-700 transition hover:text-brand-600 focus:outline-none focus:ring-2 focus:ring-brand-200 disabled:cursor-not-allowed disabled:text-slate-400"
    >
      <span aria-hidden="true" className="text-base leading-none">+</span>
      <FormattedMessage id={labelId} />
    </button>
  );
}
